import type { ReactNode } from 'react';

export const symbol_tilt_arrow_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M155-120q-28.72 0-46.86-22.5T96-193l134-600q5-20 21.5-33.5T289-840h382q21 0 37.5 13.5T730-793l134 600q6 28-12.14 50.5T805-120H155Zm-1-60h651L671-780H288L154-180Zm296-347v197q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-197l53 53q9 9 21.1 9 12.1 0 20.9-9 9-9 9-21t-9-21L501-620q-9-9-21-9t-21 9L355-516q-9 9-9 21.16t8.61 21Q364-465 376.1-465q12.1 0 20.9-9l53-53Zm355 347H154h651Z"
		/>
	</svg>
);
